import React from 'react';

// Independence declaration — verbatim wording supplied by the firm
// (do not reword), shared by Engagement Registration and Signed Financial Statements.
// `sub` renders as an indented a./b. list.
export const INDEPENDENCE_INTRO = 'I confirm that I have:';
export const INDEPENDENCE_ITEMS = [
  { text: 'a) Completed the independence confirmation and am independent of the client in all respects;' },
  {
    text: 'b) I am unaware of any circumstance which might represent;',
    sub: [
      'a. A threat to the firms’ independence in respect of the above client including self-interest, self-review, advocacy, familiarity or intimidation threats as described in EP 100 Code of Professional Conduct and Ethics (“EP 100”), IESBA International Code of Ethics for Professional Accountants (including International Independence Standards) (“IESBA Code of Ethics”), Code of Professional Conduct and Ethics for public accountants and accounting entities (“ACRA Code”), and the firm’s Quality Management Manual (“QMM”); and',
      'b. A conflict of interest situation existing in respect of the above client.',
    ],
  },
  { text: 'c) Should circumstances change which raise an independence threat I will immediately inform the lead engagement partner.' },
];

// One-line restatement of item a) for read-only reminders (modification modals).
export const INDEPENDENCE_REMINDER = 'I confirm that I have completed the independence confirmation and am independent of the client in all respects.';

export const IndependenceDeclaration = ({ checked, onChange, confirmLabel }) => (
  <div className="border border-slate-200 rounded-lg p-3 bg-slate-50 space-y-1.5">
    <p className="text-xs text-slate-600 leading-relaxed">{INDEPENDENCE_INTRO}</p>
    {INDEPENDENCE_ITEMS.map(item => (
      <div key={item.text} className="space-y-1.5">
        <p className="text-xs text-slate-600 leading-relaxed pl-4">{item.text}</p>
        {(item.sub || []).map(s => (
          <p key={s} className="text-xs text-slate-600 leading-relaxed pl-10">{s}</p>
        ))}
      </div>
    ))}
    <label className="flex items-start gap-2 text-sm text-slate-800 font-medium pt-2">
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} className="mt-0.5" />
      {confirmLabel}
    </label>
  </div>
);

export default IndependenceDeclaration;
